module.exports = __webpack_public_path__ + "img/teamfoto.290a504a.jpg";